import React from "react"

const GaryGrunewald = (
  <>
    <p>
    <strong>Machinist Mate 1st Class MM1 (SS), US Navy Veteran</strong><br />
    </p>
    <p>Served six years in the navy as a staff instructor at A1W reactor and then on USS Plunger (SSN-595). After the Navy Gary spent 26 years with the Ada County Sheriff's Office before retiring in 2021. Currently the USSVI Boise Base (submarine Veterans) commander.</p>
  </>
)

export default GaryGrunewald
